import React from 'react';
import { Form, Select, Row, Col, Tree, Input } from 'antd';
import { convertModuleByGuid } from "rt-sd-comp";
import { copy } from 'rt-sd-common';
const FormItem = Form.Item;
const Option = Select.Option;
const TreeNode = Tree.TreeNode;

const formItemLayout3 = {
    labelCol: { span: 12 },
    wrapperCol: { span: 12 }
};

const formItemLayout2 = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 }
};

const formItemLayout2_noTree = {
    labelCol: { span: 23 },
    style: {
        width: "100%",
        margin: "1px -7px 1px auto"
    }
};
const formItemLayout3_noTree = {
    labelCol: { span: 14 },
    wrapperCol: { span: 10 },
};

let createFormInfo = function (thisObj, dataRef, matchType, value1, value2) {

    dataRef.desId = dataRef.desId || "EP_EO_UI_3101";//添加默认值-文本框
    let moveStyle = {};
    if (dataRef.desId === "EP_EO_UI_3101" && dataRef.bdText) {
        // 文本组件存在后置文本时需要进行偏移，这是antd的bug，修复后这里可以取消
        moveStyle.marginTop = 4;
        moveStyle.marginBottom = -4;
    }

    let attc = dataRef.c;
    let text = dataRef.te;

    let bdInst = attc + "_tmp";

    let ctl2ShowFlg = false;

    //显示的所有属性的集合
    thisObj.state.checkedAtts[attc] = true;

    thisObj.state.objFct.set(bdInst, thisObj.state.formsValue[attc]);

    //修改c值，给每组值起同样的key
    dataRef.cRef = attc;
    let dataRef1 = copy(dataRef);
    dataRef1.c = "value1";
    dataRef1.isLbl = true;
    if (value1) dataRef1.value = value1;
    let ctl1 = convertModuleByGuid(thisObj, dataRef1, bdInst, thisObj.state.objFct, "N");
    ctl1.ref = thisObj.refModalFunction.bind(thisObj);
    let dataRef2 = copy(dataRef);
    dataRef2.c = "value2";
    // dataRef2.isLbl = false;
    // dataRef2.te = '-';
    dataRef2.isLbl = true;
    dataRef2.ctlW = 24;
    dataRef2.lblW = 2;
    // dataRef2.alwBlk = true;
    if (value2) dataRef2.value = value2;
    let ctl2 = convertModuleByGuid(thisObj, dataRef2, bdInst, thisObj.state.objFct, "N");
    if (matchType && (matchType == "Between" || matchType == "NotBetween")) {
        ctl2.ref = thisObj.refModalFunction.bind(thisObj);
        ctl2ShowFlg = true;
    } else {
        delete ctl2.ref;
        ctl2ShowFlg = false;
    }

    let ctl1Span = 6;
    if (matchType && (matchType == "In" || matchType == "NotIn")) {
        ctl1Span = 13;
    }

    if (thisObj.props.noTree) {
        if (!ctl2ShowFlg) {
            ctl1Span = 13;
        }
        thisObj.state.forms[attc] = <Row >
            <Col span={dataRef.matchDis ? 7 : 12}>
                {/* <Col span={10}> */}
                <FormItem style={{ 'margin-bottom': "1px", 'margin-top': "1px" }} {...(dataRef.matchDis ? formItemLayout2_noTree : formItemLayout3_noTree)} hasFeedback={false} label={text}>
                    {dataRef.matchDis ?
                        null
                        :
                        <Select disabled={dataRef.matchDis} value={thisObj.state.formsValue[attc]["match_type"]} style={{ width: '100%' }} onChange={this.handleChange.bind(this, attc, "match_type", dataRef)}>
                            {getExpressOptions()}
                        </Select>
                    }
                </FormItem>
            </Col>
            {dataRef.matchDis ? null : <Col span={1}></Col>}
            <Col span={ctl1Span}>
                <div style={{ ...moveStyle, float: "left", width: "100%" }}>{ctl1}</div>
            </Col>
            {ctl2ShowFlg ?
                <Col span={1} >
                    <div style={{ textAlign: "center", marginTop: 9 }}>~</div>
                </Col>
                : null}
            {ctl2ShowFlg ?
                <Col span={6} style={{ display: thisObj.state.formsValue[attc]["ctl2Display"] }}>
                    <div style={{ ...moveStyle, float: "left", width: "100%" }}>{ctl2}</div>
                </Col>
                : null}
        </Row>
    } else {
        thisObj.state.forms[attc] = <Row>
            <Col span={10}>
                <FormItem {...formItemLayout3} style={{ 'margin-bottom': "1px", 'margin-top': "1px" }} hasFeedback={false} label={text}>
                    <Select disabled={dataRef.matchDis} value={thisObj.state.formsValue[attc]["match_type"]} style={{ width: '100%' }} onChange={thisObj.handleChange.bind(thisObj, attc, "match_type", dataRef)}>
                        {getExpressOptions()}
                    </Select>
                </FormItem>
            </Col>
            <Col span={1}>
            </Col>
            <Col span={ctl1Span}>
                <div style={{ ...moveStyle, float: "left", width: "100%" }}>{ctl1}</div>
            </Col>
            {/* <Col span={1} style={{ display: thisObj.state.formsValue[attc]["ctl2Display"] }}>
            <FormItem colon={false} labelCol={{ span: 23 }} label={"-----"} />
        </Col> */}
            {ctl2ShowFlg ?
                <Col span={1} >
                    <div style={{ textAlign: "center", marginTop: 9 }}>~</div>
                </Col>
                : null}
            {ctl2ShowFlg ?
                <Col span={6} style={{ display: thisObj.state.formsValue[attc]["ctl2Display"] }}>
                    <div style={{ ...moveStyle, float: "left", width: "100%" }}>{ctl2}</div>
                </Col>
                : null}
            {/* <Col span={1} style={{ display: ctl2ShowFlg ? undefined : "none" }}>
            <FormItem colon={false} labelCol={{ span: 23 }} label="--" />
        </Col>
        <Col span={6} style={{ display: thisObj.state.formsValue[attc]["ctl2Display"] }}>
            {ctl2}
        </Col> */}
        </Row>
    }

}
let createFormInfo_readOnly = function (thisObj, dataRef, matchType, value1, value2) {

    dataRef.desId = dataRef.desId || "EP_EO_UI_3101";//添加默认值-文本框
    let moveStyle = {};
    if (dataRef.desId === "EP_EO_UI_3101" && dataRef.bdText) {
        // 文本组件存在后置文本时需要进行偏移，这是antd的bug，修复后这里可以取消
        moveStyle.marginTop = 4;
        moveStyle.marginBottom = -4;
    }

    let attc = dataRef.c;
    let text = dataRef.te;

    let bdInst = attc + "_tmp";

    let ctl2ShowFlg = false;

    //显示的所有属性的集合
    thisObj.state.checkedAtts[attc] = true;

    thisObj.state.objFct.set(bdInst, thisObj.state.formsValue[attc]);

    //修改c值，给每组值起同样的key
    dataRef.cRef = attc;
    let dataRef1 = copy(dataRef);
    dataRef1.c = "value1";
    dataRef1.isLbl = true;
    dataRef1.isDis = true;
    if (value1) dataRef1.value = value1;
    let ctl1 = convertModuleByGuid(thisObj, dataRef1, bdInst, thisObj.state.objFct, "N");
    ctl1.ref = thisObj.refModalFunction.bind(thisObj);
    let dataRef2 = copy(dataRef);
    dataRef2.c = "value2";
    dataRef2.isLbl = true;
    dataRef2.isDis = true;
    // dataRef2.te = '-';
    dataRef2.ctlW = 24;
    dataRef2.lblW = 2;
    dataRef2.alwBlk = true;
    if (value2) dataRef2.value = value2;
    let ctl2 = convertModuleByGuid(thisObj, dataRef2, bdInst, thisObj.state.objFct, "N");
    if (matchType && (matchType == "Between" || matchType == "NotBetween")) {
        ctl2.ref = thisObj.refModalFunction.bind(thisObj);
        ctl2ShowFlg = true;
    } else {
        delete ctl2.ref;
        ctl2ShowFlg = false;
    }

    let ctl1Span = 6;
    if (matchType && (matchType == "In" || matchType == "NotIn")) {
        ctl1Span = 13;
    }

    thisObj.state.forms[attc] = <Row>
        <Col span={10}>
            <FormItem {...formItemLayout3} style={{ 'margin-bottom': "1px", 'margin-top': "1px" }} hasFeedback={false} label={text}>
                <Select disabled={true} value={thisObj.state.formsValue[attc]["match_type"]} style={{ width: '100%' }} onChange={thisObj.handleChange.bind(thisObj, attc, "match_type", dataRef)}>
                    {getExpressOptions()}
                </Select>
            </FormItem>
        </Col>
        <Col span={1}>
        </Col>
        <Col span={ctl1Span}>
            <div style={{ ...moveStyle, float: "left", width: "100%" }}>{ctl1}</div>
        </Col>
        {ctl2ShowFlg ?
            <Col span={1} >
                <div style={{ textAlign: "center", marginTop: 9 }}>~</div>
            </Col>
            : null}
        {ctl2ShowFlg ?
            <Col span={6} style={{ display: thisObj.state.formsValue[attc]["ctl2Display"] }}>
                <div style={{ ...moveStyle, float: "left", width: "100%" }}>{ctl2}</div>
            </Col>
            : null}
        {/* <Col span={1} style={{ display: thisObj.state.formsValue[attc]["ctl2Display"] }}>
            <FormItem colon={false} labelCol={{ span: 23 }} label={"-----"} />
        </Col> */}
        {/* <Col span={6} style={{ display: thisObj.state.formsValue[attc]["ctl2Display"] }}>
            <div style={{ ...moveStyle, float: "left", width: "100%" }}>{ctl2}</div>
        </Col> */}
    </Row>
}


/**
 *  获取  表达式  的标准代码StandardCode
 */
let getExpressOptions = function () {

    let expressSC = StandardCode.getSC('param_SC_param_0002');

    if (!expressSC) {
        return <Option value="">不存在</Option>
    }

    let expressOptions = [];
    expressSC.forEach(element => {
        expressOptions.push(<Option value={element.c}>{element.te}</Option>)
    });

    return expressOptions;
}

let createSimpleFormInfo = function (thisObj, dataRef, matchType, value1, value2) {

    dataRef.desId = dataRef.desId || "EP_EO_UI_3101";//添加默认值-文本框

    let attc = dataRef.c;
    let text = dataRef.te;

    let bdInst = attc + "_tmp";

    //显示的所有属性的集合
    thisObj.state.checkedAtts[attc] = true;

    thisObj.state.objFct.set(bdInst, thisObj.state.formsValue[attc]);

    //修改c值，给每组值起同样的key
    dataRef.cRef = attc;
    let dataRef1 = copy(dataRef);
    dataRef1.c = "value1";
    dataRef1.isLbl = true;
    if (value1) dataRef1.value = value1;
    let ctl1 = convertModuleByGuid(thisObj, dataRef1, bdInst, thisObj.state.objFct, "N");
    ctl1.ref = thisObj.refModalFunction.bind(thisObj);
    let dataRef2 = copy(dataRef);
    dataRef2.c = "value2";
    dataRef2.isLbl = false;
    dataRef2.te = '-';
    dataRef2.ctlW = 24;
    dataRef2.lblW = 2,
        dataRef2.alwBlk = true;
    if (value2) dataRef2.value = value2;
    let ctl2 = convertModuleByGuid(thisObj, dataRef2, bdInst, thisObj.state.objFct, "N");
    if (matchType && (matchType == "Between" || matchType == "NotBetween")) {
        ctl2.ref = thisObj.refModalFunction.bind(thisObj);
    } else {
        delete ctl2.ref;
    }

    thisObj.state.forms[attc] = <FormItem colon={false} {...formItemLayout2} style={{ 'margin-bottom': "1px", 'margin-top': "-3px" }} hasFeedback={false} label={text}>
        {ctl1}
    </FormItem>
}

/**
 * key使用_key,_key没有自动创建
* @param {*} data
*/
let renderTreeNodes = (data, parentDataRef) => {
    return data.map((item) => {
        item._key = item._key || tool.uuid();
        if (item.cldSet) {
            return (
                <TreeNode title={item.te} key={item._key} dataRef={item} parentDataRef={parentDataRef}>
                    {renderTreeNodes(item.cldSet, item)}
                </TreeNode>
            );
        }
        return <TreeNode title={item.te} key={item._key} dataRef={item} parentDataRef={parentDataRef} />;
    });
}

let onSelect = function (selectedKeys, info) {
    tool.sgiLogger.info('onSelect', info);
    this.setState({ selectedKeys });
}

let onExpand = function (expandedKeys) {
    tool.sgiLogger.info('onExpand', expandedKeys);
    // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    // or, you can remove all expanded children keys.
    this.setState({
        expandedKeys,
        // autoExpandParent: false,
    });
}

export {
    createFormInfo, createFormInfo_readOnly, createSimpleFormInfo,
    getExpressOptions,
    renderTreeNodes, onSelect, onExpand
};


// WEBPACK FOOTER //
// ./apps/pages/paramMng/common.js